import { createSlice } from "@reduxjs/toolkit";

import {
  getContracts,
  // createTask,
  getbuckets,
  getContractsforcompany,
  getVendorLists,
  getContractByVendor,
  getAddendumTask,
  getContractDetails,
  getcontractVerify,
  getAcceptorrejectobligation,
  createAddendumforTasks,
  createRenewofTasks,
  getRenewalsInfoOfContract,
  getarchiveContracts,
  createChildContracts,
  getFamilyContractInfo,
  CreateRelationwithContracts,
  getLinkageDropdownList,
  streamAIsearch,
  streamAIsearchold,
  addObligationsToContract,
  getAddendumListByContractId,
  getSessions,
  getChatBySessionsId,
  // AIserach,
  // deleteTaskComment
} from "./myContract.Action";
const initialState = {
  isLoading: false,
  contractTableData: [],
  contractPagination: {
    total: 0,
    pageSize: 10,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  defaultcontractPagination: {
    total: 0,
    pageSize: 10,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  taskMgmtStatus: {
    1: {
      name: "open",
      color: "#e17b27",
      tagcolor: "green",
      id: 1,
    },
    4: {
      name: "approval_in_progress",
      color: "#01aef0",
      id: 4,
      tagcolor: "processing",
    },

    5: {
      name: "approved",
      color: "#8ec63f",
      id: 5,
    },
    6: {
      name: "rejected",
      color: "#800000",
      id: 6,
      tagcolor: "error",
    },
    7: {
      name: "completed",
      color: "green",
      id: 6,
      tagcolor: "success",
    },
    8: {
      name: "signature_inprogress",
      color: "#077E8C",
      id: 6,
    },
    9: {
      name: "expired",
      color: "red",
      id: 6,
      tagcolor: "error",
    },
    10: {
      name: "update_request",
      color: "#5BC0DE",
      id: 7,
      tagcolor: "purple",
    },
    11: {
      name: "update_accepted",
      color: "green",
      id: 8,
      tagcolor: "green",
    },
    12: {
      name: "update_rejected",
      color: "red",
      id: 9,
    },
    13: {
      name: "update_completed",
      color: "#5CB85C",
      id: 10,
    },
    14: {
      name: "aborted",
      color: "cyan",
      id: 10,
    },
    15: {
      name: "internal_review",
      color: "#01aef0",
      id: 15,
      tagcolor: "processing",
    },
    16: {
      name: "review_completed",
      color: "green",
      id: 16,
    },
    18: {
      name: "reviewed",
      color: "#0f8167",
      id: 18,
    },
  },
  ismycontractviewVisible: false,
  contractviewdetails: {},
  companycontractTableData: [],
  filterpopovervisible: false,
  filtervendorpopovervisible: false,
  bucketsname: false,
  iscompanycontractSuccess: false,
  iscontractSuccess: false,
  is_active_View: "default",
  isDetailDrawer: false,
  ticketDetails: {},
  vendorListData: [],
  vendorTableLoading: false,
  vendorContractList: [],

  addendumTaskLoading: false,
  addendumTaskData: [],

  ismyaddednDumviewVisible: false,
  addendumViewdetails: {},

  isDetailLoading: false,
  contractDetails: {},
  vendorActivePanel: "",
  vendor_contractPagination: {
    total: 0,
    pageSize: 10,
    defaultCurrent: 1,
    current: 1,
    sortBy: "DESC",
    showSizeChanger: true,
    search: "",
    orderBy: "createdAt",
  },
  isContractVerifyModalvisible: false,
  iscontractverifing: false,
  iscompanyfilterApplied: false,
  isvendorfilterApplied: false,
  obligationviewmodalVisible: false,
  isacceptorrejectedLoading: false,
  isAcceptingorRejecting: false,
  isobligationrejectmodalVisible: false,
  obligationrejectmodalRecord: {},
  isaddendummodalVisible: false,
  isaddendumCreating: false,
  istaskrenewCreating: false,
  isRenewmodalVisible: false,
  isrenewsuccessfull: false,
  vendorsloading: false,
  renewalInfo: {},
  isChildCreationModalVisible: false,
  childCreationModalType: "",
  archiveContractsList: [],
  familyContractInfo: {},
  isFamilyContractInfoLoading: false,
  ischildCreating: false,
  LinkageDropdownList: [],
  isLinkageDropdownListLoading: false,
  AnalysisreportModalVisible: false,
  isAnalysisLoading: false,
  AnalysisreportRecord: {},
  isAISearchDrawerVisible: false,
  AISearchRecord: {},
  AIsearchChats: [],
  isAITyping: false,
  isaddObligationToContractDrawerVisible: false,
  addObligationToContractDrawerRecord: {},
  isObligationAddingToContract: false,
  isAcceptorRejectSubmitted: false,
  isAcceptorRejectStatus: 1,
  isAddendumListLoading: false,
  AddendumList: [],
  chatId: null,
  sessionList: [],
  activeSession: null,
  contractDrawerType: "STANDALONE",
  editLinkageModalVisible: false,
};
const myContractsSlice = createSlice({
  name: "myContracts",
  initialState: initialState,
  reducers: {
    setchecklistModal: (state, { payload }) => {
      state.isChecklistVisible = payload.visible;
    },
    setAnalysisreportModalVisible: (state, { payload }) => {
      state.AnalysisreportModalVisible = payload?.visible;
      state.AnalysisreportRecord = payload?.record || {};
      state.isAnalysisLoading = payload?.loading || false;
    },
    defaultView: (state, { payload }) => {
      state.is_active_View = payload;
      state.contractPagination = {
        ...state.contractPagination,
        total: 0,
        pageSize: 10,
        defaultCurrent: 1,
        current: 1,
        sortBy: "DESC",
        showSizeChanger: true,
        search: "",
        orderBy: "createdAt",
      };
    },
    setValue: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
    onPageVendorChangesFilter: (state, { payload }) => {
      state.vendor_contractPagination = {
        ...state.vendor_contractPagination,
        current: payload.current,
        pageSize: payload.size,
      };
    },
    setmyContractModal: (state, { payload }) => {
      state.ismycontractviewVisible = payload.visible;
      state.contractviewdetails = payload.record || {};
    },
    setmyAddendumModal: (state, { payload }) => {
      state.ismyaddednDumviewVisible = payload.visible;
      state.addendumViewdetails = payload.record || {};
      state.addendumTaskData = payload.addendums || [];
    },
    setContractViewModal: (state, { payload }) => {
      state.isContractViewVisible = payload.visible;
      state.contractViewDetails = payload.record || {};
    },
    onPageChangesFilter: (state, { payload }) => {
      state.contractPagination = {
        ...state.contractPagination,
        current: payload.current,
        pageSize: payload.size,
      };
    },
    filterchangepagination: (state, { payload }) => {
      if (Object.keys(payload).length === 0) {
        state.contractPagination = {
          ...state.defaultcontractPagination,
        };
      } else {
        state.contractPagination = {
          ...state.contractPagination,
          ...payload,
        };
      }
    },
    vendorfilterchangepagination: (state, { payload }) => {
      if (Object.keys(payload).length === 0) {
        state.contractPagination = {
          ...state.defaultcontractPagination,
        };
      } else {
        state.contractPagination = {
          ...state.contractPagination,
          ...payload,
        };
      }
    },
    onSearchList: (state, action) => {
      state.contractPagination = {
        ...state.contractPagination,
        search: action.payload.search || "",
      };
    },
    Contractdatareset: (state, action) => {
      return initialState;
    },
    filterpopoverhandleOpenChange: (state, { payload }) => {
      state.filterpopovervisible = payload;
    },
    filtervendorpopoverhandleOpenChange: (state, { payload }) => {
      state.filtervendorpopovervisible = payload;
    },
    setcontractsuccessModal: (state, { payload }) => {
      state.iscontractsuccessVisible = payload;
    },
    openDetailDrawer: (state, { payload }) => {
      state.isDetailDrawer = payload.visible;
      state.ticketDetails = payload.record || {};
      state.contractDrawerType =
        payload?.record?.relationshipType || "STANDALONE";
    },
    setContractVerifyModal: (state, { payload }) => {
      state.isContractVerifyModalvisible = payload.visible;
      // state.iscustomconfirmdata = payload.record || {};
    },
    getcompanyfilterActive: (state, { payload }) => {
      state.iscompanyfilterApplied = payload;
      // state.iscustomconfirmdata = payload.record || {};
    },
    getvendorfilterActive: (state, { payload }) => {
      state.isvendorfilterApplied = payload;
      // state.iscustomconfirmdata = payload.record || {};
    },
    setobligationviewmodalVisible: (state, { payload }) => {
      state.obligationviewmodalVisible = payload.visible;
      // state.iscustomconfirmdata = payload.record || {};
    },
    setobligationRejectmodalVisible: (state, { payload }) => {
      state.isobligationrejectmodalVisible = payload.visible;
      state.obligationrejectmodalRecord = payload.record || {};
    },
    setcreateaddendumModelVisible: (state, { payload }) => {
      state.isaddendummodalVisible = payload.visible;
      // state.obligationrejectmodalRecord = payload.record || {};
    },
    setcreateRenewModelVisible: (state, { payload }) => {
      state.isRenewmodalVisible = payload.visible;
      // state.obligationrejectmodalRecord = payload.record || {};
    },
    setChildCreationModalVisible: (state, { payload }) => {
      state.isChildCreationModalVisible = payload.visible;
      state.childCreationModalType = payload?.type || "";
      // state.obligationrejectmodalRecord = payload.record || {};
    },
    setChildCreationModalType: (state, { payload }) => {
      state.childCreationModalType = payload;
    },
    setAISearchDrawerVisible: (state, { payload }) => {
      state.isAISearchDrawerVisible = payload?.visible || false;
      state.AISearchRecord = payload?.record || {};
      if (payload?.visible && state.AIsearchChats.length === 0) {
        state.AIsearchChats = [
          {
            sessionId: "",
            content: "Hello! How can I help you today?",
            role: "bot",
            timestamp: new Date(),
          },
        ];
      }
    },
    setAIsearchChats: (state, { payload }) => {
      console.log("payload", payload);
      state.AIsearchChats = [...state.AIsearchChats, payload];
    },
    setClearAIsearchChats: (state, { payload }) => {
      state.AIsearchChats = initialState.AIsearchChats;
      state.chatId = null;
    },
    appendAIMessage: (state, action) => {
      console.log("appendAIMessage", action.payload);
      state.AIsearchChats.push(action.payload);
      state.isAISearchDrawerVisible = true;
    },
    startAITyping: (state) => {
      state.isAITyping = true;
    },
    setAITyping: (state, action) => {
      state.isAITyping = action.payload;
    },
    showThinking: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `🤔 Thinking: ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    showToolUsage: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `🔧 Using tool: ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    showToolResult: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `📦 Tool Result: ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    showFinalAnswer: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `✅ Final Answer: ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    showIntermediateResponse: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `💬 ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    showError: (state, action) => {
      state.AIsearchChats.push({
        id: `${Date.now()}`,
        text: `❌ Error: ${action.payload}`,
        sender: "bot",
        timestamp: new Date(),
      });
    },
    SetaddObligationToContractDrawerVisible: (state, { payload }) => {
      state.isaddObligationToContractDrawerVisible = payload?.visible;
      state.addObligationToContractDrawerRecord = payload?.record || {};
    },
    setisAcceptorRejectObligationRecord: (state, { payload }) => {
      state.isAcceptorRejectSubmitted = payload?.visible;
      state.isAcceptorRejectStatus = payload?.status;
    },
    setThreadId: (state, { payload }) => {
      state.chatId = payload;
    },
    setActiveSession: (state, { payload }) => {
      state.activeSession = payload;
    },
    setCustomContractDetails: (state, { payload }) => {
      state.contractDetails = payload || {};
      state.contractDrawerType = payload?.parentContractId
        ? "ADDENDUM"
        : "STANDALONE";
    },
    setEditLinkageModalVisible: (state, { payload }) => {
      state.editLinkageModalVisible = payload?.visible || false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContracts.pending, (state) => {
        state.isLoading = true;
        state.contractTableData = [];
      })
      .addCase(getContracts.fulfilled, (state, { payload }) => {
        state.contractTableData = payload.data;
        state.isLoading = false;
        state.filtervendorpopovervisible = false;
        state.totalCount = payload.total;
        state.contractPagination = {
          ...state.contractPagination,
          total: payload.total,
        };
      })
      .addCase(getContracts.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(getContractsforcompany.pending, (state) => {
        state.isLoading = true;
        state.companycontractTableData = [];
      })
      .addCase(getContractsforcompany.fulfilled, (state, { payload }) => {
        state.companycontractTableData = payload.data;
        state.isLoading = false;
        state.filterpopovervisible = false;
        state.totalCount = payload.total;
        state.contractPagination = {
          ...state.contractPagination,
          total: payload.total,
        };
      })
      .addCase(getContractsforcompany.rejected, (state, { payload }) => {
        state.isLoading = false;
      })
      .addCase(getbuckets.pending, (state) => {})
      .addCase(getbuckets.fulfilled, (state, { payload }) => {
        state.bucketsname = payload.data;
      })
      .addCase(getbuckets.rejected, (state, { payload }) => {})
      .addCase(getVendorLists.pending, (state) => {
        state.vendorsloading = true;
      })
      .addCase(getVendorLists.fulfilled, (state, { payload }) => {
        state.vendorListData = payload.data;
        state.vendorsloading = false;
      })
      .addCase(getVendorLists.rejected, (state, { payload }) => {
        state.vendorsloading = false;
      })

      .addCase(getContractByVendor.pending, (state) => {
        state.vendorTableLoading = true;
        state.vendorContractList = [];
      })
      .addCase(getContractByVendor.fulfilled, (state, { payload }) => {
        state.vendorContractList = payload.data;
        state.vendor_contractPagination = {
          ...state.vendor_contractPagination,
          total: payload.total,
        };
        state.vendorTableLoading = false;
      })
      .addCase(getContractByVendor.rejected, (state, { payload }) => {
        state.vendorTableLoading = false;
      })

      .addCase(getAddendumTask.pending, (state) => {
        state.addendumTaskLoading = true;
      })
      .addCase(getAddendumTask.fulfilled, (state, { payload }) => {
        state.addendumTaskData = payload.data;
        state.addendumTaskLoading = false;
      })
      .addCase(getAddendumTask.rejected, (state, { payload }) => {
        state.addendumTaskLoading = false;
      })
      .addCase(getContractDetails.pending, (state) => {
        state.isDetailLoading = true;
        state.contractDetails = {};
      })
      .addCase(getContractDetails.fulfilled, (state, { payload }) => {
        state.contractDetails = payload?.data || {};
        state.isDetailLoading = false;
      })
      .addCase(getContractDetails.rejected, (state, { payload }) => {
        state.isDetailLoading = false;
      })
      .addCase(getcontractVerify.pending, (state) => {
        state.iscontractverifing = true;
      })
      .addCase(getcontractVerify.fulfilled, (state, { payload }) => {
        state.iscontractverifing = false;
      })
      .addCase(getcontractVerify.rejected, (state, { payload }) => {
        state.iscontractverifing = false;
      })
      .addCase(getAcceptorrejectobligation.pending, (state) => {
        state.isacceptorrejectedLoading = true;
      })
      .addCase(getAcceptorrejectobligation.fulfilled, (state, { payload }) => {
        state.isacceptorrejectedLoading = false;
        state.isAcceptingorRejecting = true;
        state.isobligationrejectmodalVisible = false;
        state.obligationrejectmodalRecord = {};
      })
      .addCase(getAcceptorrejectobligation.rejected, (state, { payload }) => {
        state.isacceptorrejectedLoading = false;
      })
      .addCase(createAddendumforTasks.pending, (state) => {
        state.isaddendumCreating = true;
      })
      .addCase(createAddendumforTasks.fulfilled, (state, { payload }) => {
        state.isaddendumCreating = false;
        state.isaddendummodalVisible = false;
      })
      .addCase(createAddendumforTasks.rejected, (state, { payload }) => {
        state.isaddendumCreating = false;
      })
      .addCase(createRenewofTasks.pending, (state) => {
        state.istaskrenewCreating = true;
      })
      .addCase(createRenewofTasks.fulfilled, (state, { payload }) => {
        state.istaskrenewCreating = false;
        state.isrenewsuccessfull = true;

        state.isRenewmodalVisible = false;
      })
      .addCase(createRenewofTasks.rejected, (state, { payload }) => {
        state.istaskrenewCreating = false;
      })
      .addCase(getRenewalsInfoOfContract.pending, (state) => {})
      .addCase(getRenewalsInfoOfContract.fulfilled, (state, { payload }) => {
        state.renewalInfo = payload?.data;
      })
      .addCase(getRenewalsInfoOfContract.rejected, (state, { payload }) => {})
      .addCase(getarchiveContracts.pending, (state) => {})
      .addCase(getarchiveContracts.fulfilled, (state, { payload }) => {
        state.archiveContractsList = payload?.data;
      })
      .addCase(getarchiveContracts.rejected, (state, { payload }) => {})
      .addCase(createChildContracts.pending, (state) => {})
      .addCase(createChildContracts.fulfilled, (state, { payload }) => {
        // state.archiveContractsList = payload?.data;
      })
      .addCase(createChildContracts.rejected, (state, { payload }) => {})
      .addCase(getFamilyContractInfo.pending, (state) => {
        state.isFamilyContractInfoLoading = true;
      })
      .addCase(getFamilyContractInfo.fulfilled, (state, { payload }) => {
        state.isFamilyContractInfoLoading = false;
        state.familyContractInfo = payload?.data?.data || {};
      })
      .addCase(getFamilyContractInfo.rejected, (state, { payload }) => {
        state.isFamilyContractInfoLoading = false;
      })
      .addCase(CreateRelationwithContracts.pending, (state) => {
        state.ischildCreating = true;
      })
      .addCase(CreateRelationwithContracts.fulfilled, (state, { payload }) => {
        state.isChildCreationModalVisible = false;
        state.ischildCreating = false;
        state.contractDetails = payload?.data;
        state.editLinkageModalVisible = false;
      })
      .addCase(CreateRelationwithContracts.rejected, (state, { payload }) => {
        state.ischildCreating = false;
      })
      .addCase(getLinkageDropdownList.pending, (state) => {
        // state.ischildCreating = true;
        state.isLinkageDropdownListLoading = true;
      })
      .addCase(getLinkageDropdownList.fulfilled, (state, { payload }) => {
        // state.isChildCreationModalVisible = false;
        // state.ischildCreating = false;
        state.isLinkageDropdownListLoading = false;

        state.LinkageDropdownList = payload?.data;
      })
      .addCase(getLinkageDropdownList.rejected, (state, { payload }) => {
        // state.ischildCreating = false;
        state.isLinkageDropdownListLoading = false;
      })
      .addCase(streamAIsearch.pending, (state) => {
        state.isAITyping = true;
      })
      .addCase(streamAIsearch.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.isAITyping = false;
        if (payload?.data?.aiResponse?.thread_id) {
          state.chatId = payload?.data?.aiResponse?.thread_id;
        }
        state.AIsearchChats = [
          ...state.AIsearchChats,
          {
            content: payload?.data?.aiResponse?.data?.content,
            role: "assistant",

            timestamp: new Date(),
            sessionId: payload?.data?.aiResponse?.thread_id || "",
          },
        ];
      })
      .addCase(streamAIsearch.rejected, (state, { payload }) => {
        // state.ischildCreating = false;
        state.isAITyping = false;
      })
      .addCase(streamAIsearchold.pending, (state) => {
        state.isAITyping = true;
      })
      .addCase(streamAIsearchold.fulfilled, (state, { payload }) => {
        console.log(payload);
        state.isAITyping = false;
        if (payload?.thread_id) {
          state.chatId = payload?.thread_id;
        }
        state.AIsearchChats = [
          ...state.AIsearchChats,
          {
            content: payload?.content,
            role: "assistant",
            timestamp: new Date(),
            sessionId: payload?.thread_id || "",
          },
        ];
      })
      .addCase(streamAIsearchold.rejected, (state, { payload }) => {
        // state.ischildCreating = false;
        state.isAITyping = false;
      })
      .addCase(addObligationsToContract.pending, (state) => {
        state.isObligationAddingToContract = true;
      })
      .addCase(addObligationsToContract.fulfilled, (state, { payload }) => {
        state.isObligationAddingToContract = false;
        state.isaddObligationToContractDrawerVisible = false;
      })
      .addCase(addObligationsToContract.rejected, (state, { payload }) => {
        state.isObligationAddingToContract = false;
      })
      .addCase(getAddendumListByContractId.pending, (state) => {
        state.isAddendumListLoading = true;
      })
      .addCase(getAddendumListByContractId.fulfilled, (state, { payload }) => {
        state.isAddendumListLoading = false;
        state.AddendumList = payload?.data || [];
      })
      .addCase(getAddendumListByContractId.rejected, (state, { payload }) => {
        state.isAddendumListLoading = false;
      })
      .addCase(getSessions.pending, (state) => {
        // state.isAddendumListLoading = true;
      })
      .addCase(getSessions.fulfilled, (state, { payload }) => {
        console.log("getSessions payload", payload);
        // state.isAddendumListLoading = false;
        state.sessionList = payload?.sessions || [];
      })
      .addCase(getSessions.rejected, (state, { payload }) => {
        // state.isAddendumListLoading = false;
      })
      .addCase(getChatBySessionsId.pending, (state) => {
        // state.isAddendumListLoading = true;
      })
      .addCase(getChatBySessionsId.fulfilled, (state, { payload }) => {
        console.log("getSessions payload", payload);
        // state.isAddendumListLoading = false;
        state.AIsearchChats = payload?.data?.history || [];
      })
      .addCase(getChatBySessionsId.rejected, (state, { payload }) => {
        // state.isAddendumListLoading = false;
      });
  },
});
export const {
  setmyContractModal,
  setModalVisible,
  onPageChangesFilter,
  onSearchList,
  Contractdatareset,
  filterpopoverhandleOpenChange,
  filtervendorpopoverhandleOpenChange,
  setcontractsuccessModal,
  filterchangepagination,
  vendorfilterchangepagination,
  defaultView,
  openDetailDrawer,
  setmyAddendumModal,
  setValue,
  onPageVendorChangesFilter,
  setContractVerifyModal,
  getcompanyfilterActive,
  getvendorfilterActive,
  setobligationviewmodalVisible,
  setobligationRejectmodalVisible,
  setcreateaddendumModelVisible,
  setcreateRenewModelVisible,
  setChildCreationModalVisible,
  setChildCreationModalType,
  setAnalysisreportModalVisible,
  setAISearchDrawerVisible,
  setAIsearchChats,
  appendAIMessage,
  startAITyping,
  setAITyping,
  showThinking,
  showToolUsage,
  showToolResult,
  showFinalAnswer,
  showIntermediateResponse,
  showError,
  SetaddObligationToContractDrawerVisible,
  setisAcceptorRejectObligationRecord,
  setThreadId,
  setClearAIsearchChats,
  setActiveSession,
  setCustomContractDetails,
  setEditLinkageModalVisible,
} = myContractsSlice.actions;

export default myContractsSlice.reducer;
